import BaseCommand from "@/models/api/commands/BaseCommand";

export interface FormOfPaymentBankAccount {
  BankAccountId: number;
  BankName: string;
  AccountNumber: string;
  Swift: string;
}

export interface FormOfPaymentChangeCommandParams {
  FormOfPaymentId: number;
  BankAccountId: null | number;
}

export class FormOfPaymentChangeCommand extends BaseCommand {
  CommandName = "FormOfPaymentChange";
  Command: FormOfPaymentChangeCommandParams;
  constructor(sessionId: string, operationId: string, params: FormOfPaymentChangeCommandParams) {
    super(sessionId, operationId);
    this.Command = params;
  }
}
